import React from "react";
import {TableHeaderColumn} from 'material-ui/Table';

const AvailabilityHeadingCell = ({style, heading, dayOfWeek, className}) => {

  return (
      <TableHeaderColumn style={style} className={className}>
        <div className="top">
          {dayOfWeek}
        </div>
        <div className="bottom">
        {heading}
        </div>
      </TableHeaderColumn>
  )
};

export default AvailabilityHeadingCell;


// WEBPACK FOOTER //
// ./src/components/AvailabilityHeadingCell.js